import {
	__experimentalVStack as VStack,
	__experimentalHStack as HStack,
	__experimentalText as WCText,
	Button,
} from '@wordpress/components';
import { __, _x, _n, sprintf } from '@wordpress/i18n';
import type { PaginationProps } from './types';

export default function Pagination( {
	currentPage,
	numPages,
	changePage,
	totalItems,
}: PaginationProps ) {
	return (
		<VStack className="block-editor-patterns__grid-pagination-wrapper">
			<WCText variant="muted">
				{ sprintf(
					// translators: %s: Total number of patterns.
					_n( '%s item', '%s items', totalItems ),
					// `sprintf` formats numbers with `%s`.
					totalItems as unknown as string
				) }
			</WCText>
			{ numPages > 1 && (
				<HStack
					expanded={ false }
					spacing={ 3 }
					justify="flex-start"
					className="block-editor-patterns__grid-pagination"
				>
					<HStack
						expanded={ false }
						spacing={ 1 }
						className="block-editor-patterns__grid-pagination-previous"
					>
						<Button
							variant="tertiary"
							onClick={ () => changePage( 1 ) }
							disabled={ currentPage === 1 }
							aria-label={ __( 'First page' ) }
							size="compact"
							accessibleWhenDisabled
							className="block-editor-patterns__grid-pagination-button"
						>
							<span>«</span>
						</Button>
						<Button
							variant="tertiary"
							onClick={ () => changePage( currentPage - 1 ) }
							disabled={ currentPage === 1 }
							aria-label={ __( 'Previous page' ) }
							size="compact"
							accessibleWhenDisabled
							className="block-editor-patterns__grid-pagination-button"
						>
							<span>‹</span>
						</Button>
					</HStack>
					<WCText variant="muted">
						{ sprintf(
							// translators: 1: Current page number. 2: Total number of pages.
							_x( '%1$s of %2$s', 'paging' ),
							// `sprintf` formats numbers with `%s`.
							currentPage as unknown as string,
							numPages as unknown as string
						) }
					</WCText>
					<HStack
						expanded={ false }
						spacing={ 1 }
						className="block-editor-patterns__grid-pagination-next"
					>
						<Button
							variant="tertiary"
							onClick={ () => changePage( currentPage + 1 ) }
							disabled={ currentPage === numPages }
							aria-label={ __( 'Next page' ) }
							size="compact"
							accessibleWhenDisabled
							className="block-editor-patterns__grid-pagination-button"
						>
							<span>›</span>
						</Button>
						<Button
							variant="tertiary"
							onClick={ () => changePage( numPages ) }
							disabled={ currentPage === numPages }
							aria-label={ __( 'Last page' ) }
							size="compact"
							accessibleWhenDisabled
							className="block-editor-patterns__grid-pagination-button"
						>
							<span>»</span>
						</Button>
					</HStack>
				</HStack>
			) }
		</VStack>
	);
}
